export default class DafCalendar {
    constructor() {
        this.addEvents();
    }

    addEvents() {
        let lang = $('html').attr('lang') == 'he-IL' ? 'he' : 'en';
       $('#mycalendar').monthly({
            mode: 'event',
            dataType: 'json',
            locale: lang,
            weekStart: 'Sun',
            events: []
        });
    }

}